import { connectRouter } from 'connected-react-router';
import { loadingBarReducer } from 'react-redux-loading';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import History from 'helpers/History';
import companyCarePlans from 'redux/reducers/companyCarePlans';
import dailyTasks from 'redux/reducers/dailyTasks';
import dashboards from 'redux/reducers/dashboards';
import filters from 'redux/reducers/filters';
import language from 'redux/reducers/language';
import location from 'redux/reducers/location';
import messages from 'redux/reducers/messages';
import residentShiftNotes from 'redux/reducers/residentShiftNotes';
import residents from 'redux/reducers/residents';
import session from 'redux/reducers/session';
import shiftNotesCategories from 'redux/reducers/shiftNotesCategories';
import signupInvitations from 'redux/reducers/signupInvitations';
import taskStatuses from 'redux/reducers/taskStatuses';
import users from 'redux/reducers/users';
import zones from 'redux/reducers/zones';

const reducersList = {
    companyCarePlans,
    dailyTasks,
    dashboards,
    form: formReducer,
    language,
    loadingBar: loadingBarReducer,
    location,
    messages,
    residents,
    residentShiftNotes,
    router: connectRouter(History),
    session,
    shiftNotesCategories,
    signupInvitations,
    taskStatuses,
    users,
    zones,
    filters,
};

export default combineReducers(reducersList);
